// Client for Backend/QP.Api's POST /api/VSeeClinic/session — starting the
// visit (SSO -> intake -> walk-in) happens only on the backend now; see
// Backend/QP.Api/Services/VSeeClinicService.cs.
import type { VSeeJoinLinkSession, VSeeSessionConfig } from "@/types/vsee";

interface VSeeSessionApiResponse {
  domain?: string;
  roomName?: string;
  userName?: string;
  authToken?: string;
  guestInviteUrl?: string;
  joinUrl?: string;
  error?: string;
}

export async function startVSeeCall(): Promise<
  VSeeSessionConfig | VSeeJoinLinkSession
> {
  // Lowercase to match API Gateway's route exactly — ASP.NET Core routing is
  // case-insensitive locally, but API Gateway path matching is not.
  const response = await fetch("/api/vseeclinic/session", {
    method: "POST",
  });
  const body: VSeeSessionApiResponse = await response.json();

  if (!response.ok) {
    throw new Error(
      body.error ?? `Failed to start the call (${response.status})`,
    );
  }

  if (body.joinUrl) {
    return { joinUrl: body.joinUrl };
  }

  if (!body.domain || !body.roomName || !body.userName || !body.authToken) {
    throw new Error("VSee session response is missing required fields.");
  }

  return {
    domain: body.domain,
    roomName: body.roomName,
    userName: body.userName,
    authToken: body.authToken,
    guestInviteUrl: body.guestInviteUrl,
  };
}
